import styled from 'styled-components';

export const PdfWrapperStyles = styled.div`
  height: 100%;
`;
